import { z } from 'zod';

import { OtherExplanationSchema } from '@Containers/OtherExplanations/validators';

import { StakeholderAnalysisSchema } from '../StakeholderAnalysisValueChainOfBusiness/validators';
import { BusinessValueChainSchema } from '../BusinessValueChain/validators';
import {
  EMPTY_FIELD_MESSAGE,
  validateEditorEn,
  validateSpace,
  validateSpaceTextInput,
  validateTextEn,
} from '@Utils/validation';

enum IMPACT_ON_STAKEHOLDER_MESSAGE {
  INTRODUCTION_EN = 'กรุณาระบุคำบรรยายการจัดการผลกระทบต่อผู้มีส่วนได้เสียในห่วงโซ่คุณค่าของธุรกิจเป็นภาษาอังกฤษ',
  REMARK_EN = 'กรุณาระบุหมายเหตุการจัดการผลกระทบต่อผู้มีส่วนได้เสียในห่วงโซ่คุณค่าของธุรกิจเป็นภาษาอังกฤษ',
}

export const ImpactsOnStakeholdersSchema = z.object({
  introduction: z.object({
    descriptionTh: z
      .string()
      .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
    descriptionEn: z
      .string()
      .regex(validateEditorEn, IMPACT_ON_STAKEHOLDER_MESSAGE.INTRODUCTION_EN)
      .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
  }),
  businessValueChain: BusinessValueChainSchema,
  stakeholderAnalysis: StakeholderAnalysisSchema.optional(),
  otherDescriptions: z.array(OtherExplanationSchema).optional(),
  remark: z.object({
    descriptionTh: z
      .string()
      .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
    descriptionEn: z
      .string()
      .regex(validateTextEn, IMPACT_ON_STAKEHOLDER_MESSAGE.REMARK_EN)
      .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
  }),
});
